import { createContext } from "react";
import type { TrackableEvent } from "../models/AnalyticsEvent";

export type Analytics = {
  track: (event: TrackableEvent) => void;
};

const AnalyticsContext = createContext<Analytics>({ track: () => undefined });

export default AnalyticsContext;
